import React, { useState } from 'react'
import Popover from 'react-popover'
import cn from 'classnames'

import SocialPopover from 'app/components/SocialPopover'
import Share from 'app/components/SVGS/Share'
import { ISocialPopoverWithButtonProps } from './SocialPopoverWithButton.interface'

import './styles.scss'

const bc = 'social-popover-with-button'

const SocialPopoverWithButton: React.FC<ISocialPopoverWithButtonProps> = ({
  activityId,
  identityId,
  windowWidth,
  isSocialActivated,
  wrapperClass,
  t,
}) => {
  const [show, setShow] = useState(false)
  return (
    <Popover
      isOpen={Boolean(show && activityId)}
      preferPlace="below"
      tipSize={7}
      body={<SocialPopover activityId={activityId} identityId={identityId} t={t} windowWidth={windowWidth} />}
      onOuterAction={() => setShow(!show)}
    >
      {isSocialActivated && (
        <div
          className={cn(`${bc}__btn-icon-wrapper`, { [wrapperClass as string]: wrapperClass })}
          onClick={() => setShow(!show)}
        >
          <div>
            <span className={`${bc}__btn-title`}>{t('Share')}</span>
            <Share />
          </div>
        </div>
      )}
    </Popover>
  )
}

export default SocialPopoverWithButton
